import Layer from "@mozaic-ds/freemarker/js/modules/_layer";
class ProductTools extends lm.Composant {
  constructor(id) {
    super(id);
    const productToolsSelector = "#component-producttools";
    const component = document.querySelector(productToolsSelector);
    if (!component) {
      return;
    }
    const toolButtonWithLayers = component.querySelectorAll('.js-tool-layer-button');
    if (toolButtonWithLayers?.length > 0) {
      toolButtonWithLayers.forEach(toolButtonWithLayer => {
        const toolId = toolButtonWithLayer.dataset.toolId;
        if (toolId) {
          const layer = new Layer({
            'classContent': 'js-tool-layer-' + toolId
          });
          toolButtonWithLayer.addEventListener('click', () => layer.open());
        }
      });
    }
  }
}
lm.DOMReady(function () {
  new ProductTools("producttools");
});
export default ProductTools;